/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration layer (BOL) Notifications API
 * Business Orchestration layer (BOL) Notifications API.  This API is used to manage subscriptions and consumers for BOL notifications. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Consumer,
  ConsumerCreateRequest,
  ConsumerPatchRequest,
  ErrorResponse,
  PaginatedConsumerProofsOfDelivery,
  PaginatedConsumers,
} from '../models/index';
import {
    ConsumerFromJSON,
    ConsumerToJSON,
    ConsumerCreateRequestFromJSON,
    ConsumerCreateRequestToJSON,
    ConsumerPatchRequestFromJSON,
    ConsumerPatchRequestToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    PaginatedConsumerProofsOfDeliveryFromJSON,
    PaginatedConsumerProofsOfDeliveryToJSON,
    PaginatedConsumersFromJSON,
    PaginatedConsumersToJSON,
} from '../models/index';

export interface CreateConsumerRequest {
    contentType: CreateConsumerContentTypeEnum;
    subscriptionId: string;
    consumerCreateRequest: ConsumerCreateRequest;
    accept?: CreateConsumerAcceptEnum;
    traceparent?: string;
    id?: string;
    source?: boolean;
}

export interface DeleteConsumerByIdRequest {
    subscriptionId: string;
    consumerId: string;
    accept?: DeleteConsumerByIdAcceptEnum;
    traceparent?: string;
}

export interface GetConsumerByIdRequest {
    subscriptionId: string;
    consumerId: string;
    accept?: GetConsumerByIdAcceptEnum;
    traceparent?: string;
}

export interface GetConsumerProofsOfDeliveryRequest {
    subscriptionId: string;
    consumerId: string;
    accept?: GetConsumerProofsOfDeliveryAcceptEnum;
    traceparent?: string;
    offset?: number;
    limit?: number;
}

export interface ListConsumersRequest {
    subscriptionId: string;
    accept?: ListConsumersAcceptEnum;
    traceparent?: string;
    offset?: number;
    limit?: number;
}

export interface PatchConsumerByIdRequest {
    contentType: PatchConsumerByIdContentTypeEnum;
    subscriptionId: string;
    consumerId: string;
    consumerPatchRequest: ConsumerPatchRequest;
    accept?: PatchConsumerByIdAcceptEnum;
    traceparent?: string;
}

/**
 * 
 */
export class ConsumersApi extends runtime.BaseAPI {

    /**
     * ## Description  Create a new consumer for subscription `subscriptionId`.  ## Access Control  **AD Entra ID Role**: `BOL.NOTIFICATIONS.SUBSCRIPTIONS.Manage` 
     * Create a new consumer for a subscription.
     */
    async createConsumerRaw(requestParameters: CreateConsumerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Consumer>> {
        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling createConsumer().'
            );
        }

        if (requestParameters['subscriptionId'] == null) {
            throw new runtime.RequiredError(
                'subscriptionId',
                'Required parameter "subscriptionId" was null or undefined when calling createConsumer().'
            );
        }

        if (requestParameters['consumerCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'consumerCreateRequest',
                'Required parameter "consumerCreateRequest" was null or undefined when calling createConsumer().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['source'] != null) {
            queryParameters['source'] = requestParameters['source'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/notifications/subscriptions/{subscriptionId}/consumers`;
        urlPath = urlPath.replace(`{${"subscriptionId"}}`, encodeURIComponent(String(requestParameters['subscriptionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ConsumerCreateRequestToJSON(requestParameters['consumerCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConsumerFromJSON(jsonValue));
    }

    /**
     * ## Description  Create a new consumer for subscription `subscriptionId`.  ## Access Control  **AD Entra ID Role**: `BOL.NOTIFICATIONS.SUBSCRIPTIONS.Manage` 
     * Create a new consumer for a subscription.
     */
    async createConsumer(requestParameters: CreateConsumerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Consumer | null | undefined > {
        const response = await this.createConsumerRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 201:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * ## Description  Delete a consumer for subscription `subscriptionId` by `consumerId`.  Deleting a consumer will stop all notifications to this consumer. This operation is irreversible.  ## Access Control  **AD Entra ID Role**: `BOL.NOTIFICATIONS.SUBSCRIPTIONS.Manage` 
     * Delete a consumer for a subscription by consumerId.
     */
    async deleteConsumerByIdRaw(requestParameters: DeleteConsumerByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['subscriptionId'] == null) {
            throw new runtime.RequiredError(
                'subscriptionId',
                'Required parameter "subscriptionId" was null or undefined when calling deleteConsumerById().'
            );
        }

        if (requestParameters['consumerId'] == null) {
            throw new runtime.RequiredError(
                'consumerId',
                'Required parameter "consumerId" was null or undefined when calling deleteConsumerById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/notifications/subscriptions/{subscriptionId}/consumers/{consumerId}`;
        urlPath = urlPath.replace(`{${"subscriptionId"}}`, encodeURIComponent(String(requestParameters['subscriptionId'])));
        urlPath = urlPath.replace(`{${"consumerId"}}`, encodeURIComponent(String(requestParameters['consumerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ## Description  Delete a consumer for subscription `subscriptionId` by `consumerId`.  Deleting a consumer will stop all notifications to this consumer. This operation is irreversible.  ## Access Control  **AD Entra ID Role**: `BOL.NOTIFICATIONS.SUBSCRIPTIONS.Manage` 
     * Delete a consumer for a subscription by consumerId.
     */
    async deleteConsumerById(requestParameters: DeleteConsumerByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteConsumerByIdRaw(requestParameters, initOverrides);
    }

    /**
     * ## Description  Get a consumer for subscription `subscriptionId` by `consumerId`.  ## Access Control  **AD Entra ID Role**: `BOL.NOTIFICATIONS.SUBSCRIPTIONS.Manage` 
     * Get a consumer for a subscription by consumerId.
     */
    async getConsumerByIdRaw(requestParameters: GetConsumerByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Consumer>> {
        if (requestParameters['subscriptionId'] == null) {
            throw new runtime.RequiredError(
                'subscriptionId',
                'Required parameter "subscriptionId" was null or undefined when calling getConsumerById().'
            );
        }

        if (requestParameters['consumerId'] == null) {
            throw new runtime.RequiredError(
                'consumerId',
                'Required parameter "consumerId" was null or undefined when calling getConsumerById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/notifications/subscriptions/{subscriptionId}/consumers/{consumerId}`;
        urlPath = urlPath.replace(`{${"subscriptionId"}}`, encodeURIComponent(String(requestParameters['subscriptionId'])));
        urlPath = urlPath.replace(`{${"consumerId"}}`, encodeURIComponent(String(requestParameters['consumerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConsumerFromJSON(jsonValue));
    }

    /**
     * ## Description  Get a consumer for subscription `subscriptionId` by `consumerId`.  ## Access Control  **AD Entra ID Role**: `BOL.NOTIFICATIONS.SUBSCRIPTIONS.Manage` 
     * Get a consumer for a subscription by consumerId.
     */
    async getConsumerById(requestParameters: GetConsumerByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Consumer> {
        const response = await this.getConsumerByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  Get proofs of delivery for consumer `consumerId` of subscription `subscriptionId`.  ## Access Control  **AD Entra ID Role**: `BOL.NOTIFICATIONS.SUBSCRIPTIONS.Manage` 
     * Get proofs of delivery for a consumer.
     */
    async getConsumerProofsOfDeliveryRaw(requestParameters: GetConsumerProofsOfDeliveryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedConsumerProofsOfDelivery>> {
        if (requestParameters['subscriptionId'] == null) {
            throw new runtime.RequiredError(
                'subscriptionId',
                'Required parameter "subscriptionId" was null or undefined when calling getConsumerProofsOfDelivery().'
            );
        }

        if (requestParameters['consumerId'] == null) {
            throw new runtime.RequiredError(
                'consumerId',
                'Required parameter "consumerId" was null or undefined when calling getConsumerProofsOfDelivery().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/notifications/subscriptions/{subscriptionId}/consumers/{consumerId}/proofs-of-delivery`;
        urlPath = urlPath.replace(`{${"subscriptionId"}}`, encodeURIComponent(String(requestParameters['subscriptionId'])));
        urlPath = urlPath.replace(`{${"consumerId"}}`, encodeURIComponent(String(requestParameters['consumerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedConsumerProofsOfDeliveryFromJSON(jsonValue));
    }

    /**
     * ## Description  Get proofs of delivery for consumer `consumerId` of subscription `subscriptionId`.  ## Access Control  **AD Entra ID Role**: `BOL.NOTIFICATIONS.SUBSCRIPTIONS.Manage` 
     * Get proofs of delivery for a consumer.
     */
    async getConsumerProofsOfDelivery(requestParameters: GetConsumerProofsOfDeliveryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedConsumerProofsOfDelivery> {
        const response = await this.getConsumerProofsOfDeliveryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  List consumers for subscription `subscriptionId`. Browsing consumers must be done in a paginated way, using parameters `limit` and `offset`.  ## Access Control  **AD Entra ID Role**: `BOL.NOTIFICATIONS.SUBSCRIPTIONS.Manage` 
     * List consumers for a subscription.
     */
    async listConsumersRaw(requestParameters: ListConsumersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedConsumers>> {
        if (requestParameters['subscriptionId'] == null) {
            throw new runtime.RequiredError(
                'subscriptionId',
                'Required parameter "subscriptionId" was null or undefined when calling listConsumers().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/notifications/subscriptions/{subscriptionId}/consumers`;
        urlPath = urlPath.replace(`{${"subscriptionId"}}`, encodeURIComponent(String(requestParameters['subscriptionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedConsumersFromJSON(jsonValue));
    }

    /**
     * ## Description  List consumers for subscription `subscriptionId`. Browsing consumers must be done in a paginated way, using parameters `limit` and `offset`.  ## Access Control  **AD Entra ID Role**: `BOL.NOTIFICATIONS.SUBSCRIPTIONS.Manage` 
     * List consumers for a subscription.
     */
    async listConsumers(requestParameters: ListConsumersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedConsumers> {
        const response = await this.listConsumersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  Patch a consumer for subscription `subscriptionId` by `consumerId`.  ## Access Control  **AD Entra ID Role**: `BOL.NOTIFICATIONS.SUBSCRIPTIONS.Manage` 
     * Patch a consumer for a subscription by consumerId.
     */
    async patchConsumerByIdRaw(requestParameters: PatchConsumerByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Consumer>> {
        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling patchConsumerById().'
            );
        }

        if (requestParameters['subscriptionId'] == null) {
            throw new runtime.RequiredError(
                'subscriptionId',
                'Required parameter "subscriptionId" was null or undefined when calling patchConsumerById().'
            );
        }

        if (requestParameters['consumerId'] == null) {
            throw new runtime.RequiredError(
                'consumerId',
                'Required parameter "consumerId" was null or undefined when calling patchConsumerById().'
            );
        }

        if (requestParameters['consumerPatchRequest'] == null) {
            throw new runtime.RequiredError(
                'consumerPatchRequest',
                'Required parameter "consumerPatchRequest" was null or undefined when calling patchConsumerById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/notifications/subscriptions/{subscriptionId}/consumers/{consumerId}`;
        urlPath = urlPath.replace(`{${"subscriptionId"}}`, encodeURIComponent(String(requestParameters['subscriptionId'])));
        urlPath = urlPath.replace(`{${"consumerId"}}`, encodeURIComponent(String(requestParameters['consumerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ConsumerPatchRequestToJSON(requestParameters['consumerPatchRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConsumerFromJSON(jsonValue));
    }

    /**
     * ## Description  Patch a consumer for subscription `subscriptionId` by `consumerId`.  ## Access Control  **AD Entra ID Role**: `BOL.NOTIFICATIONS.SUBSCRIPTIONS.Manage` 
     * Patch a consumer for a subscription by consumerId.
     */
    async patchConsumerById(requestParameters: PatchConsumerByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Consumer> {
        const response = await this.patchConsumerByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const CreateConsumerContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateConsumerContentTypeEnum = typeof CreateConsumerContentTypeEnum[keyof typeof CreateConsumerContentTypeEnum];
/**
 * @export
 */
export const CreateConsumerAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateConsumerAcceptEnum = typeof CreateConsumerAcceptEnum[keyof typeof CreateConsumerAcceptEnum];
/**
 * @export
 */
export const DeleteConsumerByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type DeleteConsumerByIdAcceptEnum = typeof DeleteConsumerByIdAcceptEnum[keyof typeof DeleteConsumerByIdAcceptEnum];
/**
 * @export
 */
export const GetConsumerByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetConsumerByIdAcceptEnum = typeof GetConsumerByIdAcceptEnum[keyof typeof GetConsumerByIdAcceptEnum];
/**
 * @export
 */
export const GetConsumerProofsOfDeliveryAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetConsumerProofsOfDeliveryAcceptEnum = typeof GetConsumerProofsOfDeliveryAcceptEnum[keyof typeof GetConsumerProofsOfDeliveryAcceptEnum];
/**
 * @export
 */
export const ListConsumersAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type ListConsumersAcceptEnum = typeof ListConsumersAcceptEnum[keyof typeof ListConsumersAcceptEnum];
/**
 * @export
 */
export const PatchConsumerByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type PatchConsumerByIdContentTypeEnum = typeof PatchConsumerByIdContentTypeEnum[keyof typeof PatchConsumerByIdContentTypeEnum];
/**
 * @export
 */
export const PatchConsumerByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type PatchConsumerByIdAcceptEnum = typeof PatchConsumerByIdAcceptEnum[keyof typeof PatchConsumerByIdAcceptEnum];
